import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { CompanyPaymentDetail } from 'src/app/models/CompanyPaymentDetail';
@Injectable({
    providedIn: 'root'
})
export class CompanyPaymentDetailApi extends Api<CompanyPaymentDetail> {
}